import {RestApiService} from '../../../../rest-api.service';
import {Observable} from 'rxjs';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {
    EmailClientConnectionRes,
    EmailClientReq,
    EmailClientRes
} from '../../../../../contracts/v0/administration/email.contracts';
import {ApiV0AdminIntegrations} from './api.v0.admin.integrations';

export class ApiV0AdminIntEmailClient {
    segment = '/EmailClient';

    constructor(
        v0: ApiV0AdminIntegrations,
        private rest: RestApiService,
    ) {
        this.segment = v0.segment + this.segment;
    }

    add(dto: EmailClientReq): Observable<EmailClientRes> {
        return this.rest.post<EmailClientReq, EmailClientRes>(`${this.segment}`, EmailClientRes, dto);
    }

    details(id: number): Observable<EmailClientRes> {
        return this.rest.get<EmailClientRes>(`${this.segment}/${id}`, EmailClientRes);
    }

    update(id: number, dto: EmailClientReq): Observable<EmailClientRes> {
        return this.rest.post<EmailClientReq, EmailClientRes>(`${this.segment}/${id}`, EmailClientRes, dto);
    }

    search(dto?: SearchModel): Observable<BaseCollectionModel<EmailClientRes>> {
        dto = dto ?? new SearchModel({});
        return this.rest.post<SearchModel, BaseCollectionModel<EmailClientRes>>(`${this.segment}/search`, EmailClientRes, dto);
    }

    delete(id: number): Observable<void> {
        return this.rest.delete(
            `${this.segment}/${id}`,
        );
    }

    testConnection(item: EmailClientReq): Observable<EmailClientConnectionRes> {
        return this.rest.post<EmailClientReq, EmailClientConnectionRes>(`${this.segment}/test`, EmailClientRes, item);
    }
}